<div class="home-page">
  <mc-banner></mc-banner>
  <div class="container page">
    <div class="row">
      <div class="col-md-9">
        <mc-feed-toggler></mc-feed-toggler>
        <mc-feed [apiUrl]="apiUrl"></mc-feed>
      </div>
      <div class="col-md-3">
        <mc-popular-tags></mc-popular-tags>
      </div>
    </div>
  </div>
</div>
